<template>
   <div class="ancillary-reissue-datepicker-container" :class="change ? 'date-has-change' : ''">
      <div class="input-placeholder-wrapper" @click="handlerShowDatePicker">
         <div class="ancillary-reissue-datepicker-icon-wrapper"></div>
         <div class="ancillary-reissue-datepicker-input-wrapper">
            <label for=""> {{ label }}</label>
            <!-- <span>{{ datepickerInput | FormatterDate }}- {{ dateStr }}</span> -->
            <span>{{ DateModel == "Invalid date" ? "" : DateModel | FormatterDate }}</span>
         </div>
      </div>

      <div class="ancillary-reissue-datepicker-wrapper">
         <UIDatepicker2 v-model="DateModel" inline custom-header ref="datePicker" :min="MinDate" />
      </div>
   </div>
</template>

<script>
import moment from "moment";
import UIDatepicker2 from "@/components/unitary/form2/UIDatePicker2.vue";
export default {
   name: "AncillaryReissueDatepicker",
   components: {
      UIDatepicker2,
   },
   props: {
      label: String,
      datepickerInput: String,
      minDateLimit: [String, Boolean],
   },
   data() {
      return {
         dateStr: moment(this.datepickerInput).format(this.$constants.dateFormat),
         change: false,
      };
   },
   computed: {
      DateModel: {
         get() {
            return moment(this.datepickerInput).format(this.$constants.dateFormat);
         },
         set(val) {
            this.dateStr = val;
         },
      },
      MinDate() {
         return this.minDateLimit != false
            ? moment(this.minDateLimit).format(this.$constants.dateFormat)
            : moment().format(this.$constants.dateFormat);
      },
   },

   methods: {
      handlerShowDatePicker() {
         this.$refs.datePicker.datepicker.status = true;
      },
      handlerHideDatePicker() {
         this.$refs.datePicker.datepicker.status = false;
      },
   },
   watch: {
      dateStr: {
         handler: function () {
            this.$emit("selected-date", this.dateStr);
         },
      },
      datepickerInput: {
         handler: function () {
            this.change = true;

            setTimeout(() => {
               this.change = false;
            }, 1500);
         },
      },
   },
};
</script>

<style lang="scss" scoped>
.ancillary-reissue-datepicker-container {
   display: flex;
   flex-direction: row;
   align-items: center;
   background-color: #fff;
   border: 1px solid #e6e7eb;
   border-radius: 0.5rem;
   position: relative;
   height: 56px;
   padding: 0.5rem 1rem;
   width: 100%;
   margin-left: 1rem;
   @media (max-width: 576px) {
      margin-left: 0;
   }

   @keyframes dateattention {
      from {
         background-color: #fff;
      }
      to {
         background-color: #e0fce6;
      }
   }

   &.date-has-change {
      animation-timing-function: ease-in-out;
      animation-name: dateattention;
      animation-duration: 0.25s;
      animation-iteration-count: 3;
   }

   .input-placeholder-wrapper {
      display: flex;
      align-items: center;
      width: 100%;
      cursor: pointer;
      .ancillary-reissue-datepicker-icon-wrapper {
         width: 26px;
         height: 28px;
         background-image: url("data:image/svg+xml;base64,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");
         background-repeat: no-repeat;
         background-size: contain;
      }
      .ancillary-reissue-datepicker-input-wrapper {
         display: flex;
         flex-direction: column;
         margin-left: 0.75rem;
         label {
            font-size: 0.85rem;
            opacity: 0.5;
         }
         span {
            font-weight: 500;
            min-height: 21px;
         }
      }
   }
   .ancillary-reissue-datepicker-wrapper {
      position: absolute;
      top: 100%;
      left: 0;
   }
}
</style>
